import { STORE_CONFIG, CONFIG_MODES } from '@/utils/constants/drs/store-config'
import { FRACTIONS } from '@/utils/constants/drs/fractions'

const mapConfiguration = (rootGetters, data, locationId) => {
    const setConfiguration = (options, activeMode) =>
        options.map(el => ({ ...el, isActive: el.mode === activeMode }))

    const locationName = rootGetters['drsStores/getFilterLocationData']?.full_name

    const fractions = data.fractions.map(({ id, dict_operator_id, is_active }) => ({
        ...Object.values(FRACTIONS).find(f => f.id === id),
        is_active,
        dict_operator_id,
        operatorName: rootGetters['drsOperators/getServiceByOperatorId'](dict_operator_id)?.name
    }))

    const keys = Object.values(CONFIG_MODES)
    const configModes = Object.fromEntries(
        keys.map(key => [key, setConfiguration(STORE_CONFIG[key], data[key])])
    )

    return { configModes, fractions, locationId, locationName }
}

const state = () => ({
    configuration: null
})

const mutations = {
    SET_CONFIGURATION(state, payload) {
        state.configuration = payload
    }
}

const actions = {
    async fetchAndMapConfiguration({ commit, state, rootGetters }) {
        try {
            commit('SET_CONFIGURATION', null)

            // get selected locationId from filters
            const locationId = rootGetters['drsStores/getFilters']?.locationId?.value
            if (!locationId) return

            const { data, status } = await this.$api.get(
                `drs/api/proxy/entity/location/configuration/${locationId}`,
                { config: { noCancel: true } }
            )
            if (status !== 200) {
                throw new Error('Failed fetchAndMapConfiguration')
            }
            commit('SET_CONFIGURATION', mapConfiguration(rootGetters, data, locationId))
        } catch (error) {
            console.error(error)
        }
    },

    async saveConfiguration({ dispatch, commit, rootGetters }, { locationId, payload, showNotification = true }) {
        try {
            const { status } = await this.$api.put(
                `drs/api/proxy/entity/location/configuration/${locationId}`,
                payload
            )
            if (status !== 200) {
                throw new Error('Failed saveConfiguration')
            }
            if (showNotification) {
                dispatch('addNotification', {
                    type: 'success',
                    content: 'Zmiany zapisano'
                }, { root: true })
            }
            commit('SET_CONFIGURATION', mapConfiguration(rootGetters, payload, locationId))
        } catch (error) {
            console.error(error)
            if (showNotification) {
                dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd'
                }, { root: true })
            }
        }
    }
}

const getters = {
    getConfiguration: state => state.configuration
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
